<template>
    <form @submit.prevent>
        <header>
            <h3>{{ $t('user_type') }}</h3>
            <p>{{ $t('select_type_login') }}</p>
        </header>

        <button class="guest" @click="$emit('input', 'editUser')">
            <img src="@/assets/img/robot.svg" class="icon">
            {{ $t('guest') }}
        </button>

        <button class="registered" @click="$emit('input', 'registered')">
            <img src="@/assets/img/user-circle.svg" class="icon">
            {{ $t('registered_user') }}
        </button>

        <!-- <facebook-login
            class="button facebook-login"
            appId="843155259678063"
            @login="getUserData"
            @sdk-loaded="sdkLoaded"
            loginLabel="Facebook account"
            logoutLabel="Facebook account"
            ref="facebook"
        /> -->

        <button class="signup" @click="$emit('input', 'signup')">
            <img src="@/assets/img/file-plus-alt.svg" class="icon">
            {{ $t('sign_up') }}
        </button>

        <button class="button--cancel" @click="$emit('cancel')">{{ $t('cancel') }}</button>
    </form>
</template>
<script>
// import FacebookLogin from 'facebook-login-vuejs'
import { mapFields } from 'vuex-map-fields'

export default {
	data () {
		return {
			/* Facebook Auth */
			// FB: undefined
		}
	},

	// mounted () {
	// this.$refs.facebook.isWorking = false
	// },

	computed: {
		...mapFields('router', [
			'bandList',
			'listLoading',
			'isLogin',
			'userForm'
		])
	},

	methods: {
		/* Facebook login */
		// async getUserData () {
		// 	await this.FB.api('/me', 'GET', { fields: 'id,name,email,picture' },
		// 		res => {
		// 			if (res.error) return

		// 			this.userForm.name = res.name
		// 			this.userForm.email = res.email
		// 			this.userForm.facebookId = res.id

		// 			this.$emit('input', 'facebook')

		// 			this.FB.logout()
		// 		}
		// 	)
		// },

		// sdkLoaded (payload) {
		// 	this.FB = payload.FB

		// 	if (payload.isConnected) this.getUserData()
		// }
	}

	// components: {
	// 	FacebookLogin
	// }
}
</script>
<style lang="scss" scoped>
button {
    width: 100%;
    display: flex;
    align-items: center;
    border: 2px solid;

    &:not(:last-child)    {
        margin-bottom: 1.5rem;
    }
}

.icon {
    margin-right: 2rem;
    margin-left: 2rem;
}

.guest {
    background-color: #41C6BA;
    border-color: #41C6BA;
    color: #fff;
}

.registered {
    color: #2DC4B6;
    background-color: #EEF9F8;
    border-color: #2DC4B6;
}

.facebook {
    background-color: #4268B2;
    border-color: #4268B2;
    color: #fff;
}

::v-deep .facebook-login {
    width: 100%;
    border: 2px solid #4268B2;
    background: #4268B2;
    border-radius: 0.15rem;
    margin-bottom: 1.5rem;

    button {
        width: 100%;
        background: #4268B2;
        display: flex;
        align-items: center;
        font-size: 1em;
        padding: 0.038rem 1rem;

        img {
            width: 1.2rem;
            height: 1.2rem;
            margin-right: 2rem;
            margin-left: 2rem;
            position: unset;
        }

        .spinner {
            position: unset;
            width: 1.2rem;
            height: 1.2rem;
            margin-right: 2rem;
            margin-left: 2rem;
            border: 3px solid #f3f3f3;
            border-top: 3px solid #3498db;
        }
    }

    @include mobile {
        font-size: 1em;

        button {
            img {
                margin-left: 30%;
            }
        }
    }
}

.signup {
    color: #2DC4B6;
    border-color: #2DC4B6;
    background-color: #fff;
}

.button--cancel {
    width: 5rem;
    align-self: flex-end;
    text-align: center;
    border: none;
}

@include mobile {
    button {
        height: 86px;
        text-align: center;

        .icon {
            margin-left: 30%;
        }

        &.button--cancel {
            justify-content: center;
        }
    }
}
</style>
